import { FC } from "react";
import { Box, VStack, HStack } from "@chakra-ui/react";
import useUserSummary from "hooks/useUserSummary";
import { Skeleton } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen } from "@fortawesome/free-solid-svg-icons";

const ProcessingSubmissions: FC = () => {
    const { data: userSummary, isLoading: isUserSummaryLoading } =
        useUserSummary();
    return (
        <>
            <HStack spacing={1}>
                <Box fontWeight="semibold" fontSize={18}>
                    Submissions
                </Box>
                <HStack color="#9ca3af" fontWeight="semibold" spacing={1}>
                    <Box>-</Box>

                    <Box display={{ lg: "none", xl: "block" }}>Currently</Box>
                    <Box>Processing</Box>
                </HStack>
            </HStack>
            <VStack>
                <HStack justifyContent="center">
                    <FontAwesomeIcon
                        icon={faBoxOpen}
                        size="2xl"
                        fontWeight="semibold"
                    />
                    <Box fontSize="clamp(32px, 2.5vw, 52px)">
                        {isUserSummaryLoading ? (
                            <Skeleton.Input active />
                        ) : (
                            userSummary?.processingPackagesCount
                        )}
                    </Box>
                </HStack>
            </VStack>
            <Box justifyContent="right" display="flex" width="100%">
                <Box backgroundColor="darkGray" px={2} py={1} borderRadius="md">
                    See all submissions
                </Box>
            </Box>
        </>
    );
};

export default ProcessingSubmissions;
